/**
 * Username Redirect Page
 * Resolves /u/:username to the user's profile (/profile/:id).
 * Lets @mentions link by username without duplicating the profile page.
 */

import React, { useState, useEffect } from 'react';
import { useParams, Navigate, Link } from 'react-router-dom';
import axios from 'axios';

const UsernameRedirectPage = () => {
  const { username } = useParams();
  const [id, setId] = useState(null);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let active = true;
    axios
      .get(`/api/users/by-username/${encodeURIComponent(username)}`)
      .then((res) => { if (active) { setId(res.data._id); setStatus('done'); } })
      .catch(() => { if (active) setStatus('notfound'); });
    return () => { active = false; };
  }, [username]);

  if (status === 'loading') {
    return <div className="container loading">Loading @{username}...</div>;
  }
  if (status === 'notfound') {
    return (
      <div className="container">
        <p>No user @{username} found.</p>
        <Link to="/search">Search users</Link>
      </div>
    );
  }
  return <Navigate to={`/profile/${id}`} replace />;
};

export default UsernameRedirectPage;
